import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { ActiveFilter } from '../../../../models/Table/ActiveFilter';
import { DatePipe, NgForOf, NgIf, NgStyle, NgSwitch, NgSwitchCase } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'app-active-filters',
  standalone: true,
  imports: [
    DatePipe,
    NgForOf,
    NgIf,
    NgSwitchCase,
    NgSwitch,
    NgStyle,
    OverlayPanelModule
  ],
  templateUrl: './active-filters.component.html',
})
export class ActiveFiltersComponent {
  @Input() filters: ActiveFilter[] = [];
  @Input() displayNames!: { [key: string]: string };

  @Output() onRemoveFilter = new EventEmitter<{ pos: number, filter: ActiveFilter }>();
  @Output() onClearFilters = new EventEmitter<void>();

  activeFilter: ActiveFilter | null = null;

  getName(value: any, column: string) {
    return value[column];
  }

  toggleFilterPopup(event: MouseEvent, filter: ActiveFilter, op: any) {
    if (this.activeFilter === filter) {
      this.activeFilter = null; // Cerrar el filtro seleccionado
      op.hide(); // Cerrar el panel
    } else {
      this.activeFilter = filter; // Seleccionar el nuevo filtro
      op.show(event); // Mostrar el panel
    }
  }
}